@let loaded = selectors.finishedLoading | select:false;
@let records = selectors.minimalCatalogRecords | select:[];
@let borrowingHistoryEnabled = patronSelectors.optInReadingHistory | select:false;

<mat-card class="@container/card flex shrink md:max-w-[21.75rem]">
  <mat-card-content mxHiddenUntilLoaded [reveal]="loaded">
    <p class="text-headline-small">Borrowing History</p>
    @if (borrowingHistoryEnabled && records.length > 0) {
      <div class="flex w-full flex-col gap-3 pt-[1.5rem]">
        <div class="grid grid-cols-3 @[24rem]/card:grid-cols-4 place-items-center items-center relative max-h-[5rem] gap-y-4 overflow-y-hidden">
          @for (record of records; track $index) {
            <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: record.id}" class="w-[5rem] h-[5rem]"
               [matTooltip]="record.extraData?.title">
              <mx-cover-image [catalogRecord]="record" [widthRem]="5" [heightRem]="5" [xPaddingRem]="0.25" [yPaddingRem]="0"
                              yAlignment="CENTER" xAlignment="CENTER"/>
            </a>
          }
        </div>

        <mx-link-button label="See all" endIcon="arrow_forward" routeName="BORROWING_HISTORY" class="self-end"/>
      </div>
    } @else if (!borrowingHistoryEnabled) {
      <p class="text-body-large w-full pt-3">
        You’ve chosen not to save your borrowing history. To start saving your borrowing history, enable this option in your settings.
      </p>
    } @else {
      <p class="text-body-large w-full pt-3">No recently borrowed items.</p>
    }
  </mat-card-content>
</mat-card>
